import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type LoadingAction =
  | ActionType<typeof actions.startLoading>
  | ActionType<typeof actions.finishLoading>

export interface LoadingState {
  isLoading: boolean
}

export enum LoadingActionTypes {
  START_LOADING = '@@loading/START_LOADING',
  FINISH_LOADING = '@@loading/FINISH_LOADING'
}
